import { useState } from "react";
import { Gift, ShoppingBag } from "lucide-react";
import { useAuth } from "../auth/AuthProvider";
import { Button } from "../../shared/ui/Button";
import { Card, EmptyState } from "../../shared/ui/Card";
import { StatusBadge } from "../../shared/ui/Status";
import { useShop, useShopActions } from "./useShop";
export function EnergyShopPanel() {
  const { session } = useAuth();
  const query = useShop(),
    actions = useShopActions();
  const [name, setName] = useState(() => session?.profile.name ?? ""),
    [phone, setPhone] = useState(() => session?.profile.phone ?? ""),
    [notice, setNotice] = useState(""),
    [error, setError] = useState("");
  if (!query.data) return null;
  const redeem = async (id: string) => {
    if (!name.trim() || !/^1\d{10}$/.test(phone.trim())) {
      setError("请填写领取人和正确的11位手机号。");
      return;
    }
    if (!window.confirm("确认兑换该商品？星能与库存将立即扣减。")) return;
    setNotice("");
    setError("");
    try {
      await actions.redeem({
        productId: id,
        receiverName: name,
        receiverPhone: phone,
      });
      setNotice("兑换成功，星能与库存已同步扣减，请等待门店发放。");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "兑换失败");
    }
  };
  return (
    <section className="shop-panel">
      <div className="section-divider">
        <span>星能商城</span>
        <h2>把成长兑换成喜欢的东西</h2>
      </div>
      {(notice || error) && (
        <div
          className={
            error ? "inline-notice inline-notice--error" : "inline-notice"
          }
        >
          {error || notice}
        </div>
      )}
      <div className="shop-receiver">
        <label className="v4-field">
          <span>领取人</span>
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </label>
        <label className="v4-field">
          <span>联系电话</span>
          <input value={phone} onChange={(e) => setPhone(e.target.value)} />
        </label>
      </div>
      <div className="shop-grid">
        {query.data.products
          .filter((x) => x.active)
          .map((p) => (
            <Card key={p.id} className="shop-card">
              <span className="shop-emoji">{p.imageEmoji}</span>
              <StatusBadge tone={p.stock > 0 ? "success" : "danger"}>
                {p.stock > 0 ? `库存 ${p.stock}` : "已兑完"}
              </StatusBadge>
              <h3>{p.name}</h3>
              <p>{p.description}</p>
              <div>
                <strong>
                  {p.points}
                  <small> 星能</small>
                </strong>
                <Button
                  onClick={() => redeem(p.id)}
                  disabled={actions.pending || p.stock <= 0}
                >
                  <Gift size={15} />
                  立即兑换
                </Button>
              </div>
            </Card>
          ))}
      </div>
      <Card className="directory-card">
        <div className="card-heading">
          <ShoppingBag />
          <div>
            <span>兑换记录</span>
            <h2>我的订单</h2>
          </div>
        </div>
        {query.data.orders.filter((x) => x.employeeId === session?.profile.id)
          .length ? (
          <div className="energy-history">
            {query.data.orders
              .filter((x) => x.employeeId === session?.profile.id)
              .map((o) => (
                <article key={o.id}>
                  <div>
                    <strong>{o.productName}</strong>
                    <p>
                      {o.orderNumber} ·{" "}
                      {new Date(o.createdAt).toLocaleString("zh-CN")}
                    </p>
                  </div>
                  <b>-{o.points}</b>
                  <StatusBadge
                    tone={o.status === "fulfilled" ? "success" : "warning"}
                  >
                    {o.status === "fulfilled" ? "已发放" : "待发放"}
                  </StatusBadge>
                </article>
              ))}
          </div>
        ) : (
          <EmptyState
            title="暂无兑换订单"
            description="选择心仪商品后，兑换记录会显示在这里。"
          />
        )}
      </Card>
    </section>
  );
}
